import moment from 'moment';

/**
 * Determina si el tiempo está expirado
 * @param { number } expireIn Tiempo en milisegundos
 */
export const isExpired = (expireIn) => {

    return new Date(expireIn * 1000 ).getTime() < Date.now();
}

/**
 * Convierte una fecha en el formato dd/MM/yyyy
 * @param {Number} date Fecha en milisegundos
 */
export const convertToDateString = (date) => {

    return date > 0 ? moment(date).format('DD/MM/yyyy HH:mm:ss') : null;
};